import React from 'react';
import { Typography } from 'antd';
import { primaryShades } from '../../theme/theme';
import LinearChartBox from './Charts/LinearChartBox';
import TableBox from './Tables/TableBox';
import DoubleChartsBox from './Charts/DoubleChartBox';
const { Title } = Typography;

// Costanti dei colori
const PRIMARY_700 = primaryShades.primary700;

const DynamicTables = () => {
    return (
        <div style={{ padding: 'clamp(0.625rem, 2vw, 1.25rem)' }}>
            <Title level={3} style={{ marginBottom: 'clamp(1rem, 2vw, 1.5rem)', color: PRIMARY_700, textAlign: 'left' }}>Linear Chart Box</Title>
            <LinearChartBox />

            <Title level={3} style={{ marginTop: 'clamp(1.25rem, 3vw, 2.5rem)', marginBottom: 'clamp(1rem, 2vw, 1.5rem)', color: PRIMARY_700, textAlign: 'left' }}>Table Box</Title>
            <TableBox />

            <Title level={3} style={{ marginTop: 'clamp(1.25rem, 3vw, 2.5rem)', marginBottom: 'clamp(1rem, 2vw, 1.5rem)', color: PRIMARY_700, textAlign: 'left' }}>Double Charts Box</Title>
            <DoubleChartsBox />
        </div>
    );
};

export default DynamicTables; 